import request from '@/utils/request'
const BASE_URL = '/EquipmentWarmdata'

//系统
export default {
  list(data) {
    return request({
      url: BASE_URL + '/List',
      method: 'post',
      data
    })
  },
  getLastInfo(equipmentId){
    return request({
      url: BASE_URL + '/getLastInfo',
      method: 'get',
      params:{equipmentId}
    })
  },
  save(data) {
    return request({
      url: BASE_URL + '/Save',
      method: 'post',
      data
    })
  },
 
 
}